import { render, staticRenderFns } from "./groupBooking.vue?vue&type=template&id=72976798&scoped=true&"
import script from "./groupBooking.vue?vue&type=script&lang=js&"
export * from "./groupBooking.vue?vue&type=script&lang=js&"
import style0 from "./groupBooking.vue?vue&type=style&index=0&id=72976798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72976798",
  null
  
)

export default component.exports